import type { ApplicationMode } from '../modes/applicationModes';
import { useAppStore } from '../state/useAppStore';
import { CompositionPanel } from './CompositionPanel';
import { Inspector } from './Inspector';
import { LayersPanel } from './LayersPanel';
import { MapWorkspace } from './MapWorkspace';
import { AnnotationInspector } from './annotations/AnnotationInspector';

interface WorkspaceShellProps {
  readonly mode: Exclude<ApplicationMode, 'empty'>;
}

export function WorkspaceShell({ mode }: WorkspaceShellProps) {
  const collapsed = useAppStore((state) => state.shell.layersPanelCollapsed);
  const selectedLayerId = useAppStore((state) => state.shell.selectedLayerId);
  const inspectorOpen = useAppStore((state) => state.shell.inspectorOpen);
  const activeAnnotationLayerId = useAppStore((state) => state.shell.activeAnnotationLayerId);
  const showInspector =
    inspectorOpen &&
    ((mode === 'editor' && (selectedLayerId !== null || activeAnnotationLayerId !== null)) ||
      (mode === 'composition' && selectedLayerId === null && activeAnnotationLayerId !== null));
  const showAnnotationInspector =
    showInspector && activeAnnotationLayerId !== null && selectedLayerId === null;
  const showCompositionPanel = mode === 'composition' && !showAnnotationInspector;

  return (
    <div
      className={[
        'workspace-shell',
        `workspace-shell-${mode}`,
        collapsed ? 'workspace-layers-collapsed' : '',
        showInspector ? 'workspace-has-inspector' : '',
        showCompositionPanel ? 'workspace-has-composition-panel' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <LayersPanel key={mode} mode={mode} />
      <MapWorkspace mode={mode} />
      {showInspector ? showAnnotationInspector ? <AnnotationInspector /> : <Inspector /> : null}
      {showCompositionPanel ? <CompositionPanel /> : null}
    </div>
  );
}
